import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loading, Container } from '@nextui-org/react';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  useEffect(() => {
    if (user) {
      logout().catch((error) => {
        console.error("Error signing out:", error);
      });
    }
  }, [user, logout]);

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  return (
    <Container display="flex" justify="center" alignItems="center" css={{ height: "100vh" }}>
      <Loading size="lg" />
    </Container>
  );
};

export default LogoutPage;
